import type { MemberInvitationCandidate } from '@up2d8/contracts';

/** Hulpjes voor de kaart "Nog niet uitgenodigd" (ADR-0101), zonder React zodat ze te testen zijn. */

/** Zoveel leden per verzoek: klein genoeg voor een voortgang die beweegt, groot genoeg om op te schieten. */
export const MEMBER_INVITE_CHUNK = 25;

/** De mailstatus van één lid, als woord: status nooit alleen als kleur. */
export function memberMailState(
  item: Pick<MemberInvitationCandidate, 'state' | 'mailStatus' | 'expiresAt'>,
  now: Date = new Date(),
): 'not_invited' | 'sent' | 'failed' | 'pending' | 'expired' {
  if (item.state === 'not_invited' || !item.mailStatus) return 'not_invited';
  if (item.mailStatus === 'failed') return 'failed';
  if (item.mailStatus === 'pending') return 'pending';
  if (item.expiresAt && new Date(item.expiresAt) < now) return 'expired';
  return 'sent';
}

/** De selectie in pakjes van `MEMBER_INVITE_CHUNK`. */
export function chunks<T>(items: T[], size = MEMBER_INVITE_CHUNK): T[][] {
  const out: T[][] = [];
  for (let index = 0; index < items.length; index += size) {
    out.push(items.slice(index, index + size));
  }
  return out;
}
